<template>
  <div class="left-panel-layout">
    <slot name="map">map</slot>
    <left-panel-drawer
      class="left-panel-layout__left-panel"
      :is-open="isLeftPanelOpen"
    >
      <slot name="left-panel">left-panel</slot>
    </left-panel-drawer>
    <panel v-if="false" class="layout__right-panel">
      <slot name="right-panel">right-panel</slot>
    </panel>
    <!-- <div class="layout__bottom-panel">
      <slot name="bottom-panel">bottom-panel</slot>
    </div> -->
  </div>
</template>

<script>
//  TODO: make it responsive cf anagraph/market-analysis
import LeftPanelDrawer from '../left-panel-drawer'
import Panel from '../panel'
export default {
  components: {
    LeftPanelDrawer,
    Panel
  },
  props: {
    isLeftPanelOpen: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.left-panel-layout {
  position: relative;
  width: 100vw;
  height: 100vh;
  &__right-panel {
    position: absolute;
    width: 300px;
    background-color: lightblue;
    z-index: 100;
    top: 50px;
    right: 50px;
  }
}
</style>
